/* image-gallery.js
   -----------------------------------------------------------------------------
   Behavior summary
   - TOP (feature) carousel:
       � Fades between slides
       � Non-infinite on desktop, infinite below lg (via responsive)
       � Highlights the matching thumbnail on the bottom
       � When moving beyond the currently visible bottom page, pages the bottom by one viewport

   - BOTTOM (thumbnail) carousel:
       � Non-infinite at all sizes
       � Swipe pans the rail ONLY (doesn�t change the �real� active slide)
       � Clicking a thumb sets the �real� active slide (updates TOP and adds `.is-selected`)
       � Arrows HIDING now driven by what�s actually visible:
           - Hide PREV when the **first real slide** is `.slick-active`
           - Hide NEXT when the **last real slide** is `.slick-active`
         (applies to ALL screen sizes)
       � Arrows page by a full viewport (counts configured below)

   Assumptions (provided elsewhere globally):
     - window.Bootstrap4Breakpoints_MIN  e.g., { xs:0, sm:576, md:768, lg:992, xl:1200 }
     - window.Bootstrap4Breakpoints_MAX  e.g., { xs:575, sm:767, md:991, lg:1199, xl:0 }

   >>> CONFIG: control bottom slide counts in ONE place <<<
----------------------------------------------------------------------------- */
(function ($) {
    'use strict';

    // --- Early exit if in Experience Editor ---
    if ($('body').hasClass('experience-editor')) {
        // Don�t initialize Slick in Experience Editor
        return;
    }

    // === Single source of truth for bottom rail counts ===
    var BOTTOM_VISIBLE_DESKTOP = 4; // ? lg
    var BOTTOM_VISIBLE_MOBILE = 4; // < lg  (you asked for 4 instead of 2)

    // ---------- Helpers (pure utilities) --------------------------------------

    /** Returns true if viewport is ? Bootstrap lg min (desktop). */
    function isDesktop() {
        var lgMin = (window.Bootstrap4Breakpoints_MIN && Bootstrap4Breakpoints_MIN.lg) || 992;
        return window.matchMedia('(min-width:' + lgMin + 'px)').matches;
    }

    /** Get active slidesToShow for a slick instance, falling back to our globals. */
    function getVisibleCount(slick) {
        if (slick && typeof slick.options.slidesToShow === 'number') return slick.options.slidesToShow;
        return isDesktop() ? BOTTOM_VISIBLE_DESKTOP : BOTTOM_VISIBLE_MOBILE;
    }

    /** Get active slidesToScroll for a slick instance, falling back to visible count. */
    function getScrollCount(slick) {
        if (slick && typeof slick.options.slidesToScroll === 'number') return slick.options.slidesToScroll;
        return getVisibleCount(slick);
    }

    /** Normalize an index (exclude clones) into [0..realCount-1]. */
    function normalizeIndex($slider, rawIndex) {
        var realCount = $slider.find('.slick-slide').not('.slick-cloned').length;
        if (!realCount && typeof rawIndex === 'number') return Math.max(0, rawIndex);
        var idx = rawIndex % realCount;
        if (idx < 0) idx += realCount;
        return idx;
    }

    /** Add .is-selected to the requested thumb (don�t rely on .slick-current). */
    function markSelectedThumb($thumbs, slideIndex) {
        var realIndex = normalizeIndex($thumbs, slideIndex);
        $thumbs.find('.slick-slide').removeClass('is-selected');
        $thumbs.find('.slick-slide[data-slick-index="' + realIndex + '"]').addClass('is-selected');
    }

    /** Hard-scroll the thumbnail rail to a specific slide index. */
    function scrollThumbRailToIndex(thumbsSlick, $thumbs, slideIndex, instant) {
        var realIndex = normalizeIndex($thumbs, slideIndex);
        if (thumbsSlick && typeof thumbsSlick.slickGoTo === 'function') {
            thumbsSlick.slickGoTo(realIndex, !!instant);
        } else if ($thumbs.hasClass('slick-initialized')) {
            $thumbs.slick('slickGoTo', realIndex, !!instant);
        }
    }

    /**
     * Only scroll the thumbnail rail if the target thumb is currently off-screen.
     * Avoids �snap back� if the selected thumb is already visible.
     */
    function scrollThumbRailIfOffscreen(thumbsSlick, $thumbs, slideIndex, instant) {
        if (!thumbsSlick) return;
        var realIndex = normalizeIndex($thumbs, slideIndex);
        var firstVisible = thumbsSlick.currentSlide || 0; // first visible index (page start)
        var visibleCount = getVisibleCount(thumbsSlick);
        var lastVisibleIndex = firstVisible + visibleCount - 1;

        if (realIndex < firstVisible || realIndex > lastVisibleIndex) {
            scrollThumbRailToIndex(thumbsSlick, $thumbs, realIndex, instant);
        }
    }

    /**
     * When TOP is about to change, page the bottom by ONE viewport iff the incoming
     * thumb is beyond the currently visible page. Produces the same feel as clicking
     * the bottom arrows.
     */
    function pageBottomRailForTopNavigation(thumbsSlick, $thumbs, currentTopIndex, nextTopIndex) {
        if (!thumbsSlick) return;
        var realNextIndex = normalizeIndex($thumbs, nextTopIndex);
        var firstVisible = thumbsSlick.currentSlide || 0;
        var visibleCount = getVisibleCount(thumbsSlick);
        var lastVisibleIndex = firstVisible + visibleCount - 1;

        var direction = (nextTopIndex > currentTopIndex) ? 1 : (nextTopIndex < currentTopIndex ? -1 : 0);
        if (direction > 0 && realNextIndex > lastVisibleIndex) {
            if (typeof thumbsSlick.slickNext === 'function') thumbsSlick.slickNext();
            else $thumbs.slick('slickNext');
        } else if (direction < 0 && realNextIndex < firstVisible) {
            if (typeof thumbsSlick.slickPrev === 'function') thumbsSlick.slickPrev();
            else $thumbs.slick('slickPrev');
        }
    }

    /**
     * NEW: Update bottom arrow visibility based on what�s actually visible.
     *  - Hide the entire container if total real slides ? visibleCount.
     *  - Otherwise:
     *      � Hide PREV if the **first real slide** currently has `.slick-active`
     *      � Hide NEXT if the **last real slide** currently has `.slick-active`
     *
     * This uses Slick�s own active classes so it stays correct across breakpoints,
     * paging sizes, and any internal rounding.
     */
    function updateBottomArrowVisibilityByActive($root, slick) {
        if (!slick) return;

        var $container = $root.find('.image-gallery-bottom-arrows-container');
        var $prevArrow = $container.find('.image-gallery-bottom-arrow-prev');
        var $nextArrow = $container.find('.image-gallery-bottom-arrow-next');

        var $slider = slick.$slider; // jQuery element for the thumbs slider
        var $realSlides = $slider.find('.slick-slide').not('.slick-cloned');
        var totalReal = $realSlides.length;
        var visibleCnt = getVisibleCount(slick);

        // Not enough slides to need arrows at all
        var needsArrows = totalReal > visibleCnt;
        $container.toggle(needsArrows);
        if (!needsArrows) return;

        // Check active visibility against the FIRST and LAST real slides
        var firstRealIsActive = $realSlides.first().hasClass('slick-active');
        var lastRealIsActive = $realSlides.last().hasClass('slick-active');

        // Hide prev if the first slide is fully in the active set; hide next if the last is.
        $prevArrow.toggle(!firstRealIsActive);
        $nextArrow.toggle(!lastRealIsActive);
    }

    // ---------- Init / Wiring (with detailed event docs) ----------------------

    $(function () {

        $('.image-gallery').each(function () {
            var $root = $(this);
            var $featureSlider = $root.find('.image-gallery-top-slides');     // TOP (feature)
            var $thumbSlider = $root.find('.image-gallery-bottom-slides');  // BOTTOM (thumbnails)

            // ----- TOP (feature) initialization -----------------------------------

            // Event: TOP 'init' � top slider initialized (hook present for reference)
            $featureSlider.on('init', function () { /* no-op */ });

            $featureSlider.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                infinite: false,                // desktop: non-infinite
                dots: false,
                fade: true,
                cssEase: 'linear',
                speed: 350,
                waitForAnimate: true,
                prevArrow: $root.find('.image-gallery-top-arrows-container .image-gallery-top-arrow-prev'),
                nextArrow: $root.find('.image-gallery-top-arrows-container .image-gallery-top-arrow-next'),
                responsive: [
                    // Below lg, allow looping on the feature slider
                    { breakpoint: Bootstrap4Breakpoints_MAX.lg, settings: { infinite: true } }
                ]
            });

            var thumbsSlickInstance = null; // raw Slick instance for bottom rail

            // Event: TOP 'beforeChange' � page bottom by a viewport if next thumb is off-page
            $featureSlider.on('beforeChange', function (e, slick, currentTopIndex, nextTopIndex) {
                pageBottomRailForTopNavigation(thumbsSlickInstance, $thumbSlider, currentTopIndex, nextTopIndex);
            });

            // Event: TOP 'afterChange' � update bottom highlight and nudge only if off-screen
            $featureSlider.on('afterChange', function (e, slick, currentTopIndex) {
                if (!$thumbSlider.length) return;
                markSelectedThumb($thumbSlider, currentTopIndex);
                scrollThumbRailIfOffscreen(thumbsSlickInstance, $thumbSlider, currentTopIndex, true);
                // Also refresh arrow visibility (uses active classes)
                if (thumbsSlickInstance) updateBottomArrowVisibilityByActive($root, thumbsSlickInstance);
            });

            // ----- BOTTOM (thumbs) initialization ---------------------------------

            // Event: BOTTOM 'init'
            // Store instance, align once to current top, update arrows-by-active.
            $thumbSlider.on('init', function (e, slick) {
                thumbsSlickInstance = slick;

                var initialTopIndex = $featureSlider.hasClass('slick-initialized')
                    ? $featureSlider.slick('slickCurrentSlide')
                    : 0;

                markSelectedThumb($thumbSlider, initialTopIndex);
                scrollThumbRailToIndex(thumbsSlickInstance, $thumbSlider, initialTopIndex, true);

                updateBottomArrowVisibilityByActive($root, thumbsSlickInstance);
            });

            // Keep arrow UI current on lifecycle/motion events (based on active slides)
            // - 'reInit'      : slider reinitialized (e.g., responsive)
            // - 'breakpoint'  : responsive breakpoint hit
            // - 'setPosition' : layout recalculated
            // - 'afterChange' : finished changing first visible slide
            $thumbSlider.on('reInit breakpoint setPosition afterChange', function (e, slick) {
                updateBottomArrowVisibilityByActive($root, slick);
            });

            $thumbSlider.slick({
                slidesToShow: BOTTOM_VISIBLE_DESKTOP,   // ? lg
                slidesToScroll: BOTTOM_VISIBLE_DESKTOP, // page by viewport
                arrows: true,
                infinite: false,                        // NOT infinite on any size
                dots: false,
                fade: false,
                focusOnSelect: false,                   // we handle clicks manually
                waitForAnimate: true,
                swipeToSlide: true,                     // swiping pans the rail; does NOT change �real� active
                touchThreshold: 10,
                prevArrow: $root.find('.image-gallery-bottom-arrows-container .image-gallery-bottom-arrow-prev'),
                nextArrow: $root.find('.image-gallery-bottom-arrows-container .image-gallery-bottom-arrow-next'),
                responsive: [
                    {
                        breakpoint: Bootstrap4Breakpoints_MAX.lg, // < lg
                        settings: {
                            slidesToShow: BOTTOM_VISIBLE_MOBILE,
                            slidesToScroll: BOTTOM_VISIBLE_MOBILE,
                            infinite: false,
                            swipeToSlide: true,
                            touchThreshold: 10
                        }
                    }
                ]
            });

            // ----- Bottom thumbnail click handling --------------------------------
            // Distinguish a real click from a swipe-drag using pointer down/up delta.

            // Event: BOTTOM 'mousedown' / 'touchstart' on a thumb � record pointer X
            $thumbSlider.on('mousedown touchstart', '.slick-slide', function (e) {
                var pointerDownAbsolutePageX = e.pageX || (e.originalEvent.touches && e.originalEvent.touches[0].pageX) || 0;
                this._pointerDownPageX = pointerDownAbsolutePageX;
            });

            // Event: BOTTOM 'click' on a thumb � if not a drag, make it the �real� active slide
            $thumbSlider.on('click', '.slick-slide', function (e) {
                var pointerDownPageX = this._pointerDownPageX || e.pageX;
                var pointerUpPageX = e.pageX;
                var DRAG_CLICK_TOLERANCE_PX = 5;

                if (typeof pointerUpPageX === 'number' &&
                    Math.abs(pointerUpPageX - pointerDownPageX) > DRAG_CLICK_TOLERANCE_PX) {
                    return; // treat as drag, ignore click
                }

                var rawClickedIndex = $(this).data('slick-index');
                var clickedIndex = normalizeIndex($thumbSlider, rawClickedIndex);

                if ($featureSlider.hasClass('slick-initialized')) {
                    $featureSlider.slick('slickGoTo', clickedIndex);
                }
                markSelectedThumb($thumbSlider, clickedIndex);
                scrollThumbRailToIndex(thumbsSlickInstance, $thumbSlider, clickedIndex, false);

                // Arrows may change based on new actives
                if (thumbsSlickInstance) updateBottomArrowVisibilityByActive($root, thumbsSlickInstance);
            });

            // (Optional) If you still want �instant� arrow feedback on press, you can
            // keep your predictive pointerdown handlers here. With the new active-based
            // logic most teams are happy updating on setPosition/afterChange only.
        });
    });

})(jQuery);
